import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(180deg, #f0f0f0 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: ${props => props.theme.colors.text};
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background:#ffffff;
  border-radius: 24px;
  padding: 2.5rem;
  border: 1px solid ${props => props.theme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'};
  overflow: hidden;
  min-height: 320px;
`;

const CardTitle = styled.h3`
  font-size: 1.75rem;
  margin-bottom: 1.25rem;
  color: ${props => props.theme.colors.text};
  position: relative;
`;

const HighlightedWord = styled.span`
  position: relative;
  display: inline-block;
  color: #4f46e5;
`;

const CardDescription = styled.p`
  color: ${props => props.theme.colors.text};
  opacity: 0.8;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const ImageContainer = styled.div`
  width: calc(100% + 5rem);
  height: 280px;
  overflow: visible;
  position: relative;
  margin: 10px -2.5rem -2.5rem;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const cards = [
  {
    title: "Turn Estimates into Customers",
    description: "Convert quotes into Projects without the downtime, leaving you more time to focus on your customers",
    showImage: true
  },
  {
    title: "No More Extra Paperwork",
    description: "Get Signatures and Jobsite, No Need for the Clipboard and Pen",
    showImage: false
  },
  {
    title: "Give Your Team the Tools they Need to Succeed",
    description: "Your Software should be easy to use, and your team should be able to use it to its full potential",
    showImage: false
  }
];

const TitledCards = () => {
  const getHighlightedTitle = (title) => {
    const words = title.split(' ');
    const lastWord = words.pop();
    return (
      <>
        {words.length > 0 ? `${words.join(' ')} ` : ''}
        <HighlightedWord>{lastWord}</HighlightedWord>
      </>
    );
  };

  return (
    <Section>
      <Container>
        <Title>Everything you need to manage your service business</Title>
        <Grid>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardTitle>{getHighlightedTitle(card.title)}</CardTitle>
              <CardDescription>{card.description}</CardDescription>
              {card.showImage && (
                <ImageContainer>
                  <CardImage src="Estimate1.webp" alt="Estimate Interface" />
                </ImageContainer>
              )}
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default TitledCards; 